import React, { useState, Fragment, useEffect } from 'react';
import {
  Row,
  Input,
  Label,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  CustomInput,
} from 'reactstrap';
import { Tooltip } from 'reactstrap';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import Select from 'react-select';
import Switch from 'rc-switch';
import 'rc-switch/assets/index.css';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import CustomSelectInput from '../../../../../../components/common/CustomSelectInput';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import IntlMessages from '../../../../../../helpers/IntlMessages';
import {
  postAPI_Create_Forms,
  putAPI_Update_Forms,
  gAPI_QuestionSets,
  gAPI_FormsBy_Id,
} from '../../../../../../constants/APIs';
import Validation from '../../../../../../components/Validation';
import CategoryTag from './CategoryTag';

const mediaTypeList = [
  { label: 'JPG/JPEG', value: 'jpg' },
  { label: 'PNG', value: 'png' },
  { label: 'GIF', value: 'gif' },
  { label: 'DOC', value: 'doc' },
  { label: 'PDF', value: 'pdf' },
];
function Forms({
  visible,
  formLabel,
  toggle,
  id,
  propertyId,
  locale,
  LoadData,
  languageCode,
  categoryList,
}) {
  const [inputData, setInputData] = useState({
    groupId: getGroupID(),
    propertyId: propertyId === '-1' ? null : propertyId,
    name: '',
    formType: '0',
    formContent: '',
    languageCode: languageCode,
    subject: '',
    subTitle: '',
    successMessage: '',
    status: 'Active',
    isGlobal: false,
    categories: [],
    creator: 'dashboard',
  });
  const [uploadData, setUploadData] = useState([]);
  const [globelToolTip, setGlobelToolTip] = useState(false);
  const [error, setError] = useState({ msg: '', visible: false });
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState([]);
  const [categoryTag, setCategoryTag] = useState(categoryList);
  const [selectedTag, setSelectedTag] = useState([]);
  const [addTagModel, setAddTagModel] = useState(false);
  const [assistantList, setAssistantList] = useState([]);
  const toggleGlobelToolTip = () => {
    setGlobelToolTip(!globelToolTip);
  };
  useEffect(() => {
    if (id !== undefined) {
      AxiosAPI({
        methhod: 'get',
        url: `${gAPI_FormsBy_Id}/${id}`,
      })
        .then((res) => {
          setInputData(res.data);
          if (res.data.attachmentFiles.length > 0) {
            setUploadData(res.data.attachmentFiles);
          }
          var selected = [];
          if (res.data.categories !== null && res.data.categories.length > 0) {
            res.data.categories.map((x) => {
              selected.push({ label: x, value: x });
            });
          }
          setSelectedTag(selected);
        })
        .catch((err) => console.log('err', err));
    }
    AxiosAPI({
      methed: 'get',
      url: `${gAPI_QuestionSets}/?propertyId=${propertyId}&groupId=${getGroupID()}&lang=${locale}`,
    })
      .then((res) => {
        var setslist = res.data.sets.sort(
          (a, b) => a.displayOrder - b.displayOrder
        );
        var list = [];
        if (setslist !== null && setslist.length > 0) {
          setslist
            .filter(
              (l) =>
                l.type === 'DynamicConversationFlow' &&
                l.openAiAssistantId !== ''
            )
            .map((l) => {
              list.push({ id: l.openAiAssistantId, name: l.name });
            });
        }

        setAssistantList(list);
      })
      .catch((err) => {
        console.error(
          'API error:',
          err.response ? err.response.data : err.message
        );
      });
  }, [id]);
  const AddUpload = () => {
    let links = [...uploadData];
    links.push({
      instruction: '',
      type: [],
      mandatory: false,
    });
    setUploadData(links);
  };
  const RemoveUpload = (index) => {
    const values = [...uploadData];
    values.splice(index, 1);
    setUploadData(values);
  };
  const handleChange = (e) => {
    setInputData({ ...inputData, [e.target.name]: e.target.value });
  };
  const handleCheckedGlobal = (e) => {
    setInputData({
      ...inputData,
      isGlobal: e.target.checked,
    });
  };
  function validateJson(json) {
    try {
      JSON.parse(json);
      return true;
    } catch {
      return false;
    }
  }
  const handleSubmit = () => {
    if (inputData.formContent === '') {
      setError({ msg: 'please enter content!', visible: true });
    } else if (validateJson(inputData.formContent) === false) {
      setError({ msg: 'json is not valid!', visible: true });
    } else if (validateJson(inputData.formContent)) {
      setError({ msg: '', visible: false });
      if (id === undefined) {
        var body = {
          ...inputData,
          attachmentFiles: uploadData,
        };
        AxiosAPI({
          method: 'post',
          url: `${postAPI_Create_Forms}`,
          data: body,
        })
          .then((res) => {
            if (
              res.data.HttpStatusCode !== undefined &&
              res.data.HttpStatusCode === 400 &&
              res.data.Messages !== undefined &&
              res.data.Messages !== null &&
              res.data.Messages.length > 0
            ) {
              setMsg(res.data.Messages);
              setOpen(true);
            } else {
              toggle();
              LoadData(languageCode);
            }
          })
          .catch((err) => {
            console.log('err', err);
          });
      } else {
        let body = {
          groupId: inputData.groupId,
          propertyId: inputData.propertyId,
          name: inputData.name,
          formType: inputData.formType,
          formContent: inputData.formContent,
          languageCode: inputData.languageCode,
          subject: inputData.subject,
          subTitle: inputData.subTitle,
          successMessage: inputData.successMessage,
          attachmentFiles: uploadData,
          isGlobal: inputData.isGlobal,
          categories: inputData.categories,
          dynamicConversationFlow: inputData?.dynamicConversationFlow,
          updator: 'dashboard',
        };
        AxiosAPI({
          method: 'put',
          url: `${putAPI_Update_Forms}/${id}`,
          data: body,
        })
          .then((res) => {
            if (
              res.data.HttpStatusCode !== undefined &&
              res.data.HttpStatusCode === 400 &&
              res.data.Messages !== undefined &&
              res.data.Messages !== null &&
              res.data.Messages.length > 0
            ) {
              setMsg(res.data.Messages);
              setOpen(true);
            } else {
              toggle();
              LoadData(languageCode);
            }
          })
          .catch((err) => {
            console.log('err', err);
          });
      }
    }
  };
  const hanleChangeUpload = (e, index, name) => {
    let media = [];
    let data = [...uploadData];
    if (name === 'instruction') {
      data[index].instruction = e.target.value;
    } else if (name === 'type') {
      media = e.map((a) => a.value);
      if (media.includes('jpg')) {
        media.push('jpeg');
      }
    }
    data[index].type = media;
    setUploadData(data);
  };
  const handleSwitchChange = (value, index) => {
    let data = [...uploadData];
    data[index].mandatory = value;
    setUploadData(data);
  };
  const handleChangeMultiCategory = (selectedMembershipGroup) => {
    if (selectedMembershipGroup.filter((i) => i.value === '-1').length === 0) {
      setSelectedTag(selectedMembershipGroup);
      const membershipGroupArr = selectedMembershipGroup.map(
        (elem) => elem.value
      );
      setInputData({
        ...inputData,
        categories: membershipGroupArr,
      });
    } else {
      setAddTagModel(true);
    }
  };
  const addTag = (data) => {
    setSelectedTag({ label: data, value: data });
    var exist = { ...inputData };
    var list = exist.categories === null ? [] : exist.categories;
    list.push(data);

    setInputData({
      ...inputData,
      categories: list,
    });
  };
  return (
    <Fragment>
      <Modal isOpen={visible} toggle={toggle} size="lg">
        <ModalHeader toggle={toggle}>
          {formLabel} <IntlMessages id="forms.forms-title" />
        </ModalHeader>
        <ModalBody>
          <Row>
            <Colxx md="4">
              <Row className="mb-4">
                <Colxx xxs="12" className="mb-2">
                  <Label>Title</Label>
                  <Input
                    type="text"
                    value={inputData.name}
                    name="name"
                    onChange={handleChange}
                  />
                </Colxx>
                <Colxx xxs="12" className="mb-2">
                  <Label>Form Type</Label>
                  <Input
                    type="select"
                    value={inputData.formType}
                    name="formType"
                    onChange={handleChange}
                  >
                    <option value="0">Select</option>
                    <option value="LeaveDetails">Leave Details</option>
                    <option value="Pre">Pre</option>
                    <option value="Post">Post</option>
                    <option value="Feedback">Feedback</option>
                    <option value="GroupBooking">
                      Group Booking
                    </option>
                    <option value="LongStay">Long Stay</option>
                    <option value="LostFound">Lost & Found</option>
                    <option value="InvoiceRequest">Invoice Request</option>
                    <option value="InStay">In Stay</option>
                    <option value="CheckIn">Check-In</option>
                  </Input>
                </Colxx>
                <Colxx xxs="12" className="mb-2">
                  <Label>Form Category </Label>
                  <Select
                    components={{ Input: CustomSelectInput }}
                    className="react-select"
                    classNamePrefix="react-select"
                    isMulti={true}
                    name="form-field-name"
                    value={selectedTag}
                    onChange={handleChangeMultiCategory}
                    options={categoryTag}
                  />
                </Colxx>
                <Colxx xxs="12" className="mb-2">
                  <Label>Subject</Label>
                  <Input
                    type="text"
                    value={inputData.subject}
                    name="subject"
                    onChange={handleChange}
                  />
                </Colxx>
                <Colxx xxs="12" className="mb-2">
                  <Label>Subtitle</Label>
                  <Input
                    type="textarea"
                    value={inputData.subTitle}
                    name="subTitle"
                    onChange={handleChange}
                    rows={2}
                  />
                </Colxx>
                <Colxx xxs="12" className="mb-2">
                  <Label>Success Message</Label>
                  <Input
                    type="textarea"
                    value={inputData.successMessage}
                    name="successMessage"
                    onChange={handleChange}
                    rows={2}
                  />
                </Colxx>
                {assistantList && assistantList.length > 0 && (
                  <Colxx xxs="12" className="mb-2">
                    <Label>Dynamic Conversation Flow</Label>
                    <Input
                      type="select"
                      name="dynamicConversationFlow"
                      placeholder="Dynamic Conversation Flow"
                      value={inputData?.dynamicConversationFlow}
                      onChange={handleChange}
                    >
                      <option value="">
                        Select a Dynamic Conversation Flow
                      </option>
                      {assistantList.map((assist, index) => (
                        <option key={index} value={assist.id}>
                          {`${assist.name} (${assist.id})`}
                        </option>
                      ))}
                    </Input>
                  </Colxx>
                )}
              </Row>
            </Colxx>
            <Colxx md="8">
              <Row>
                <Colxx xxs="12" className="mb-2 av-tooltip tooltip-label-right">
                  <Label className="">Form Content</Label>
                  <Input
                    type="textarea"
                    value={inputData.formContent}
                    name="formContent"
                    rows={13}
                    onChange={handleChange}
                  />
                  {error.visible && (
                    <div
                      className="invalid-feedback d-block"
                      style={{ marginLeft: '60px' }}
                    >
                      {error.msg}
                    </div>
                  )}
                </Colxx>
                <Colxx xxs="12" className="mb-2">
                  {uploadData &&
                    uploadData.length > 0 &&
                    uploadData.map((item, i) => (
                      <Row>
                        <Colxx xxs="6">
                          <Label>Instructions</Label>
                          <Input
                            type="textarea"
                            value={item.instruction}
                            name="instruction"
                            onChange={(e) =>
                              hanleChangeUpload(e, i, 'instruction')
                            }
                            rows={4}
                          />
                        </Colxx>
                        <Colxx xxs="5">
                          <Row>
                            <Colxx xxs="12">
                              <Label>Media Type</Label>
                              <Select
                                components={{ Input: CustomSelectInput }}
                                className="react-select"
                                classNamePrefix="react-select"
                                isMulti={true}
                                name="form-field-name"
                                value={mediaTypeList.filter(
                                  (i) =>
                                    item.type && item.type.includes(i.value)
                                )}
                                onChange={(e) =>
                                  hanleChangeUpload(e, i, 'type')
                                }
                                options={mediaTypeList}
                              />
                            </Colxx>
                            <Colxx xxs="12">
                              <Label>Mandatory?</Label>
                              <Switch
                                className=" agentswitch custom-switch-primary custom-switch-small"
                                checked={item.mandatory}
                                onChange={(primary) =>
                                  handleSwitchChange(primary, i)
                                }
                              />
                            </Colxx>
                          </Row>
                        </Colxx>
                        <Colxx xxs="1">
                          <Button
                            style={{ marginTop: '2rem' }}
                            color="danger"
                            size="xs"
                            outline
                            onClick={() => RemoveUpload(i)}
                          >
                            -
                          </Button>
                        </Colxx>
                      </Row>
                    ))}
                  <Button
                    className="mt-2"
                    color="secondary"
                    size="xs"
                    outline
                    onClick={() => AddUpload()}
                  >
                    + File Upload
                  </Button>
                </Colxx>
              </Row>
            </Colxx>
          </Row>
          <Row>
            <Colxx xxs="12">
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <CustomInput
                  type="checkbox"
                  id="is_globel"
                  label="Make this item globel i.e visible across all properties"
                  checked={inputData.isGlobal}
                  onChange={handleCheckedGlobal}
                />{' '}
                <i
                  className="demo-icon simple-icon-info ml-2"
                  id="globeltip"
                ></i>
                <Tooltip
                  placement="right"
                  isOpen={globelToolTip}
                  target="globeltip"
                  toggle={toggleGlobelToolTip}
                >
                  <p className="text-left">
                    This item will be visible across all the properties in your
                    group. Any changes will reflect across all the properties
                    where you are showing this item.
                    <br />
                    <br />
                    You can change the status to “Inactive” at property level,
                    if you don’t want to show for a particular property.
                  </p>
                </Tooltip>
              </div>
            </Colxx>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={handleSubmit}>
            {formLabel}
          </Button>
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
        <Validation
          open={open}
          messages={msg}
          toggle={() => {
            setOpen(!open);
          }}
        ></Validation>
      </Modal>
      {addTagModel && (
        <CategoryTag
          visible={addTagModel}
          toggle={() => setAddTagModel(false)}
          addTag={(e) => addTag(e)}
        ></CategoryTag>
      )}
    </Fragment>
  );
}
const mapStateToProps = ({ settings }) => {
  const { propertyId, locale } = settings;
  return {
    propertyId,
    locale,
  };
};

export default injectIntl(connect(mapStateToProps, {})(Forms));
